import type { TablePaginationConfig } from 'antd'
import { useState } from 'react'

import type { GpuSchemas } from '@/api/gpu/client'

import type { PageQuery } from '../hooks/useGpuOperations'

const PAGE_SIZE = 50

// Instances and reports page by page/perPage with v3-shaped totals.
export function usePagePagination() {
  const [query, setQuery] = useState<PageQuery>({
    page: 1,
    perPage: PAGE_SIZE,
  })

  const pagination = (
    received: GpuSchemas['Pagination'] | undefined,
  ): TablePaginationConfig => ({
    current: query.page,
    pageSize: query.perPage,
    total: received?.filteredRecords ?? 0,
    showSizeChanger: false,
    onChange: (page) => setQuery((q) => ({ ...q, page })),
  })

  const reset = () => setQuery((q) => ({ ...q, page: 1 }))

  return { query, pagination, reset }
}
